import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

import { NextImage } from '../NextImage';

export const Logo = styled(NextImage)`
  margin: ${({ theme }) => theme.spacing(2)};
`;

export const Body = styled(Typography)`
  text-align: center;
  max-width: 700px;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
    margin: 0 auto ${theme.spacing(2)};
    scale: ${theme.fontSizes.p0};
    color: ${theme.colors.defaultAdd3};
    line-height: ${theme.lineHeights.p0};
  `}
`;
